import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useChecklistServicoListaFilter
 */

type State = {
  tipoCampo: number;
  valorCampo: string | null;
  status: number;
};

export const initialChecklistServicoLista: State = {
  tipoCampo: 1,
  valorCampo: null,
  status: 1,
};

export const useChecklistServicoListaFilter = create<State>((set) => ({
  ...initialChecklistServicoLista,
}));